/* eslint-disable */
export default {
  hash: {
    result: {
      CN_OLD:
        "7e042408c0045f7fa00f647e5f45bf4ac055607e4055c81c40da686e4c0e8e49",
      CN: "21042418400445183115f47e62654f5ae245eb5a629d0b3c62dbcb5b66120b10",
      US: "f00002009800024089cedaeeba72da49f278da4c9a07da438a73da598bde7a6f",
      JP: "28ae0e7e5f747f4a787f487eee747a7e48365e7f4e26541c48ff7d6e482a1249",
      KR: "fe027e0026fa187e37367f7ede7a18608ecaff7e7e223c34062062ff063e3c00"
    },
    stage: {
      A: "3c007e007e007e00ff00ff01ff81e781e783c3c3ffc7ffe7ffe781ef81ff00f",
      B: "3fe03ff83ff83cf83c3c3c783ff83ff03ff83ffc3c3c3c3c3c7c3ffc3ff83ff0",
      C: "7f00ff83ffc3ffe7c3c7800f800f000f000f80078107c3f3ffe3ffc0ff807e0",
      D: "ffe0fff8fffcfffcf03ef01ef01ff01ff01ff01ff01ef03efffefffcfff8ffe0",
      E: "3ffc3ffc3ffc3ffc3c003c003ff03ff03ff03ff03c003c003ffc3ffc3ffc3ffc",
      F: "3ffc3ffc3ffc3ffc3c003c003c003ff03ff03ff03c003c003c003c003c003c00",
      G: "7e00ff83ffc3ffe7c1c7800f800f8fff8fff8ff780f7e1f3fff3fff0fff07ef",
      H: "781e781e781e781e781e781e7ffe7ffe7ffe7ffe781e781e781e781e781e781e",
      I: "3c003c003c003c003c003c003c003c003c003c003c003c003c003c003c003c0",
      J: "1e001e001e001e001e001e001e001e001e001e003e383c7ffc3ff81ff80fe0",
      K: "f83ef87cf8f8f9f0fbe0ffc0ff80ff80ffc0ffc0fbe0f9f0f8f8f87cf87cf83e",
      L: "3c003c003c003c003c003c003c003c003c003c003c003c003ffc3ffc3ffc3ffc",
      M: "f00ff81ff83ffc3ffe7ffe7ffffffffff7eff7eff3cff3cff00ff00ff00ff00f",
      N: "781e7c1e7c1e7e1e7f1e7f9e7fde7fde7bfe7bfe79fe78fe787e787e783e781e",
      O: "7e01ff83ffc7ffe7c3ef81ff00ff00ff00ff00ff81f7c3f7ffe3ffc1ff807f0",
      P: "3ff03ff83ffc3ffc3c3c3c3c3c3c3ffc3ffc3ff83ff03c003c003c003c003c00",
      Q: "7e01ff83ffc3e7c781e781e781e781e781e7c3e3ffc3ff80ff007e003c003c0",
      R: "7fe07ff87ff87ffc7c3c7c3c7c7c7ffc7ff87ff07ff07df07cf87c787c7c7c3e",
      S: "7e00ff81ffc3ffc3c3c3f001fc01ff007fc01fc0c3c3c3c3ffc1ffc0ff807f0",
      T: "7ffe7ffe7ffe7ffe03c003c003c003c003c003c003c003c003c003c003c003c0",
      U: "781e781e781e781e781e781e781e781e781e781e781e7c3e3ffc3ffc1ff80fe0",
      V: "f80ff81f781e7c1e3c3e3c3c3e7c1e781e780f780ff00ff007e007e007e003c0",
      W: "e007e18773ce73ce73ce77ee3fec3e7c3e7c1e781c381c3800000000",
      X: "7c3e7c3e3e7c3ff81ff80ff00fe007e007e00ff00ff01ff83efc3e7c7c3ef83f",
      Y: "f81f7c3e7c3c3e7c1ff81ff00ff007e003c003c003c003c003c003c003c003c0",
      Z: "7ffe7ffe7ffe7ffe00fc01f803f003e007c00fc01f803f007ffe7ffe7ffe7ffe",
      "1": "f001f003f007f00ff00ff006f002f000f000f000f000f000f000f000f000f0",
      "2": "7e00ff01ff83ffc3e7c043c007c00f801f803f007e00f803ffc3ffc3ffc3ffc",
      "3": "7e00ff81ff83e7c3c7c007c03f803f003f8007c003c3c3c3ffc3ffc1ff807e0",
      "4": "7800f801f801f803f807f80f781f783e783c787ffe7ffe7ffe007800780078",
      "5": "ff80ff81ff81ff81e001fc01ff01ff81efc043c003c1c3c3efc1ff81ff007e0",
      "6": "1f003e003c007800f801fe01ff83ffc3e7c3c3c3c3c3c3c3ffc1ffc0ff807e0",
      "7": "3ffc3ffc3ffc3ffc007800f801f001e003e003c007c007800f801f001e003e00",
      "8": "7e00ff01ff81c781c381e781ff00fe01ff83ffc3c3c3c3c3e7c3ffc1ff807e0",
      "9": "7e01ff83ff83ffc3c3c383c3c3c3e7c3ffc1ff80ff801f003e007c007800f00",
      "0": "7e01ff03ff83ffc7c3e783e781e781e781e781e783e7c3e3ffc3ffc1ff007e0",
      "-": "ffffffffffffffffffffffff00000000000000000000"
    },
    stage_new: {
      A: "3c003c003c007e007e00e700e701e381c381c3c3ffc3ffc700e700e700fe007",
      B: "3fe03ff038783838383838383ff03ff03ff8383c381c381c381c387c3ff83ff0",
      C: "7f01ff83ffc781e700c7000e000e000e000e0007000700f381e3ffc1ff807e0",
      D: "ffc0fff0e0fce03ce00ee00ee00fe007e007e00fe00ee00ee03cfffcfff0ffc0",
      E: "3ffc3ffc3ffc3800380038003ff03ff03ff038003800380038003ffc3ffc3ffc",
      F: "3ffc3ffc3ffc38003800380038003ff03ff03800380038003800380038003800",
      G: "7e01ff83ffc381e700c7000e000e07fe07fe0077007700f7c1f3fff1fff07e7",
      H: "700e700e700e700e700e700e7ffe7ffe7ffe700e700e700e700e700e700e700e",
      I: "380038003800380038003800380038003800380038003800380038003800380",
      J: "e000e000e000e000e000e000e000e000e000e000c301c783c3e7c1ff807e0",
      K: "703c707870f071e073c073807f007f807f8079c071e070e070707078703c701c",
      L: "38003800380038003800380038003800380038003800380038003ff83ff83ff8",
      M: "e007f00ff00ff81ffc3ffc3fee77ef77e7e7e3c7e3c7e187e007e007e007e007",
      N: "700e780e7c0e7c0e7e0e7f0e778e738e73ce71ee70fe707e707e703e701e700e",
      O: "7e01ff83ffc781e700ee007e007e007e007e007e00f700e781e3ffc1ff807e0",
      P: "3fe03ff83ff8383c381c381c383c38383ff83ff03f8038003800380038003800",
      Q: "7e01ff83c3c381c700e700e600e600e700e700e381c3e781ff007e001800180",
      R: "3fe03ff03ff8383838383818383838783ff83ff038e038f0387038783838381c",
      S: "7e01ff01c78383c38183c001f800fe003f8007c001c381c381c1e381ff807e0",
      T: "7ffe7ffe7ffe0380038003800380038003800380038003800380038003800380",
      U: "700e700e700e700e700e700e700e700e700e700e700e781c381c3e7c1ff807e0",
      V: "e007700e700e700e381c381c3c381c381c780e700e7007e007e007c003c003c0",
      W: "c003e187618663c673ce33cc366c366c1e781c381c380c3000000000",
      X: "781e383c3c381e780ef00fe007e003c003c007e00ff01e701c383c3c781e700e",
      Y: "700e781e383c1c380e700ff007e003c003800380038003800380038003800380",
      Z: "7ffe7ffe001e003c007800f001e003c003c007800f001e003c007bfe7ffe7ffe",
      "1": "7000f001f003f0077006700070007000700070007000700070007000700070",
      "2": "7e00ff01e783c3c181c001c003c0038007801f003c007800f001dfc3ffc3ffc",
      "3": "7e00ff01e781c38181c0038007803e003f80038001c381c383c1e780ff007e0",
      "4": "30007000f001f003b007b00f300e301c3038307ffe7ffe7ffe003000300030",
      "5": "ff80ff80c000c001c001d801ff01e781c38001c001c381c383c1e780ff007e0",
      "6": "1e001c0038007000f001fc01ff03e78383c381c381c381c3c3c1e781ff807e0",
      "7": "3ffc3ffc003800380070007000e001e001c003800380070007000e000e001c00",
      "8": "7e00ff01c38181818181c380ff007e01ff81c38381c381c381c1e780ff007e0",
      "9": "7e01ff81e78381c381c381c381c3c3c1e7c0ff807f000e001e003c003800700",
      "0": "7e01ff83ffc381c781e700e700e700e700e700e700e780e381c3ffc1ff807e0",
      "-": "ffffffffffffffff000000000000000000000000"
    },
    dropType: {
      CN: {
        NORMAL_DROP:
          "564e564ffeeffee3fee7fe47fe477cf77cf71067fe6ffe6dd2fdd6ddde97d697",
        SPECIAL_DROP:
          "4404c4fcdefcfe4fe47fff74df74c2ff7fffffeeffaeda2e4a5f4a5f46d546c4",
        EXTRA_DROP:
          "40646f64ff74f474fe74fed6fed6eef76ef7fe35be35fe24be64bee4fbc4fbc4",
        FURNITURE:
          "100010de7ede7e401000ffffffff24cc6e5efe5a7e56fe7ffe51fee010ff10bf"
      },
      US: {
        NORMAL_DROP:
          "c0001800a0000400bb27869bd02706b2b02306b1b3671a9b0000001003000010",
        SPECIAL_DROP:
          "e0089800a000800096ee83db76c88202364c8201b6ce9adb1000000010000000",
        EXTRA_DROP:
          "e100e0008100800095549fad894c9a2e8d549a29f554ebad0000002000000020",
        FURNITURE:
          "80201c0080201400956895559533155595331555f56b1d550000000400020004"
      },
      JP: {
        NORMAL_DROP:
          "3e2abe2a4a7f4c7f1e41027fde22de3e423e5e08427f427f4249604bff4a9f08",
        SPECIAL_DROP:
          "800080ff80ff8003800380128216821e86148c108c109830b030f060c0e00040",
        EXTRA_DROP:
          "a718a71ca22432257601f791bfd13a503250345424143424162c532873000",
        FURNITURE:
          "abb5abb5abb5a891a8d1a8c1acc9acc9acc9acc9a889a88988a8cba9dba9d3a9"
      },
      KR: {
        NORMAL_DROP:
          "20272daf2da9afa9afadadbf2db72fa00fa7efa7e027e627e6060607e7e7e7e",
        SPECIAL_DROP:
          "7e187e1840187e1c403c7e777e670000ffffffff00187e187e18061806180618",
        EXTRA_DROP:
          "100610067e7e7e7e181e38167c17e61742360026ff6610c610c6100610061006",
        FURNITURE:
          "201f201f2791209fe09fe198279fa79fa19023100317e610261024102010201"
      }
    },
    item: {
      CN: {
        "1": "3800f800f80018001800180018001800180018001800180018001801ff01ff0",
        "2": "7c00fe0187000300030003000300070006000e001c0038007000e001ff81ff8",
        "3": "7c00ff00c3000300030003000f003c003f0003000180018001818381ff007e0",
        "4": "6000e001e001e00360076006600c600c6018603ffc3ffc0060006000600060",
        "5": "7f00ff00c000c000c000c000fe00c700038001800180018003818381ff007c0",
        "6": "1e007f80e100c000c00180019e01ff01c301818181818180c180e3007f003e0",
        "7": "1ff81ff800300070006000c000c001c001800180018003800380038003000300",
        "8": "3c007f00c300c300c100c30073003e007e00c701838181818181c380ff007e0",
        "9": "3c00fe00c3018301818181818180c380ff807d800180030003008701fe007c0",
        "0": "3c007e00c300c301c3818181818181818181818181818380c300c3007e003c0"
      },
      US: {
        "1": "1e003e007e007e004e000e000e000e000e000e000e000e000e000e000e000e0",
        "2": "7e00ff00e300c380c380038007001f007e00f801c001c001c001c001ff81ff8",
        "3": "7e00ff01c301c380038003000f003e000f00038003800381c381c380ff00fe0",
        "4": "e001e001e003e0036007600e600e601c6018601ff81ff80060006000600060",
        "5": "1ff01ff01c001c001c001fe01ff01e701c380038003800381c381c300ff00fe0",
        "6": "7e00ff00e700c301c001dc01ff01ff01c301c381c381c380c300e700ff007e0",
        "7": "ff00ff000700070007000e000e000e000c001c0018003800380030007000700",
        "8": "7e00ff01c301c381c380c300ff007e00e701c381c381c381c381c380ff007e0",
        "9": "7e00ff01c701c301c3018381c381c380ff80ff8003000300c300c700ff007e0",
        "0": "7e00ff00e700c301c381c381c381c381c381c381c381c380c300e700ff007e0"
      },
      JP: {
        "1": "e001e007e007e006e000e000e000e000e000e000e000e000e000e000e000e0",
        "2": "7e00ff01e781c3818180038003800f003e007c00f000e001c0018001ff81ff8",
        "3": "7e00ff01e381c380018003801f003e003f80038001c081c381c1c381ff807f0",
        "4": "7000f001f003f003f007700e701c701c7038707ffc7ffc7ffc007000700070",
        "5": "1ff81ff81c00180018001bc01ff01e783838001c001c081c38381c781ff007e0",
        "6": "7e00ff81e381c18180039c03ff03ff83c38381c381c381c1c181e380ff007e0",
        "7": "3ffc3ffc00380070007000e001c001c003800380038007000700070007000700",
        "8": "7e00ff01c38181818181c381ff80ff01ff83c1c381c381c381c1c381ff807e0",
        "9": "7e00ff01c783838381c381c381c1c3c1ffc0ffc039c001818381c781ff007e0",
        "0": "7e00ff01e781c381818381c381c381c381c381c381c18181c381e780ff007e0"
      },
      KR: {
        "1": "3c01fc01fc01fc003c003c003c003c003c003c003c003c003c01ff81ff81ff8",
        "2": "7c01ff01ff01c78007800780078007000f001e003e007c00f801ff81ff81ff8",
        "3": "7e01ff01ff80c780078007801f003e003f000f80038003818781ff81ff00fe0",
        "4": "1f001f003f003f007f00f700e701e701c703ffc3ffc3ffc0070007000700070",
        "5": "ff80ff80ff80e000e000fc00ff00ff80c7800380038003818783ff81ff00fe0",
        "6": "3e007f80ff80e101e001c001ff01ff81f781c381c381c381e380ff807f003e0",
        "7": "3ff83ff83ff8007000f000e001e001c003c003c0038003800380078007800780",
        "8": "3e00ff01ff01e381c381e380f7007e00ff01ef81c781c381c381e781ff007e0",
        "9": "7c00fe01ff01c781c381c381c381e781ff807b80038007808781ff01fe00fc0",
        "0": "7e00ff00ff01e781c381c383c383c383c383c381c381c381e780ff00ff007e0"
      }
    }
  },
  stage: {
    "0-1": {
      stageId: "main_00-01",
      drops: [
        "2001",
        "30011",
        "30021",
        "30031",
        "30051",
        "30061",
        "3003",
        "2001",
        "30041",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "0-2": {
      stageId: "main_00-02",
      drops: [
        "2001",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "0-3": {
      stageId: "main_00-03",
      drops: [
        "2001",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "0-4": {
      stageId: "main_00-04",
      drops: [
        "2001",
        "30011",
        "30021",
        "30031",
        "30041",
        "30061",
        "3003",
        "2001",
        "30051",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "0-5": {
      stageId: "main_00-05",
      drops: [
        "2001",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "0-6": {
      stageId: "main_00-06",
      drops: [
        "2001",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "0-7": {
      stageId: "main_00-07",
      drops: [
        "30021",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "0-8": {
      stageId: "main_00-08",
      drops: [
        "2001",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "0-9": {
      stageId: "main_00-09",
      drops: [
        "30011",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "0-10": {
      stageId: "main_00-10",
      drops: [
        "2001",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "2001",
        "3003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "0-11": {
      stageId: "main_00-11",
      drops: [
        "30011",
        "30031",
        "30031",
        "30041",
        "30021",
        "30061",
        "3003",
        "2001",
        "30051",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "1-1": {
      stageId: "main_01-01",
      drops: [
        "30011",
        "30031",
        "30041",
        "30021",
        "30051",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "1-2": {
      stageId: "main_01-02",
      drops: [],
      existence: true
    },
    "1-3": {
      stageId: "main_01-03",
      drops: [
        "30041",
        "30011",
        "30021",
        "30031",
        "30041",
        "30061",
        "3003",
        "2001",
        "30051",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "1-4": {
      stageId: "main_01-04",
      drops: [
        "30011",
        "30021",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001",
        "30031",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "1-5": {
      stageId: "main_01-05",
      drops: [
        "30061",
        "30011",
        "30031",
        "30041",
        "30051",
        "30061",
        "30021",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "1-6": {
      stageId: "main_01-06",
      drops: [
        "30051",
        "30011",
        "30021",
        "30031",
        "30041",
        "30061",
        "3003",
        "2001",
        "30051",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "1-7": {
      stageId: "main_01-07",
      drops: [
        "30012",
        "30011",
        "30021",
        "30031",
        "30051",
        "30041",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "1-8": {
      stageId: "main_01-08",
      drops: [
        "30032",
        "30021",
        "30031",
        "30011",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "1-9": {
      stageId: "main_01-09",
      drops: [
        "3112",
        "30021",
        "30011",
        "30031",
        "30051",
        "30041",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "1-10": {
      stageId: "main_01-10",
      drops: [
        "3301",
        "30011",
        "30021",
        "30031",
        "30041",
        "30061",
        "30051",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "1-11": {
      stageId: "main_01-11",
      drops: [],
      existence: true
    },
    "1-12": {
      stageId: "main_01-12",
      drops: [
        "30062",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "2-1": {
      stageId: "main_02-01",
      drops: [
        "30042",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "2-2": {
      stageId: "main_02-02",
      drops: [
        "30022",
        "30011",
        "30021",
        "30031",
        "30051",
        "30041",
        "3003",
        "2001",
        "30061",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "2-3": {
      stageId: "main_02-03",
      drops: [
        "30061",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30062",
        "2001",
        "30032",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "2-4": {
      stageId: "main_02-04",
      drops: [
        "30013",
        "30031",
        "30011",
        "30061",
        "30012",
        "3003",
        "30062",
        "2001",
        "30032",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "2-5": {
      stageId: "main_02-05",
      drops: [
        "30023",
        "30041",
        "30021",
        "30051",
        "2001",
        "30022",
        "30052",
        "30042",
        "2002",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "2-6": {
      stageId: "main_02-06",
      drops: [
        "30033",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "2-7": {
      stageId: "main_02-07",
      drops: [
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "2-8": {
      stageId: "main_02-08",
      drops: [
        "30043",
        "30021",
        "30041",
        "30051",
        "30022",
        "30042",
        "30052",
        "2002",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "2-9": {
      stageId: "main_02-09",
      drops: [
        "30073",
        "30011",
        "30031",
        "3003",
        "30012",
        "30032",
        "30062",
        "30061",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "2-10": {
      stageId: "main_02-10",
      drops: [
        "30103",
        "30021",
        "30041",
        "30051",
        "30022",
        "2001",
        "30042",
        "2002",
        "30052",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S2-1": {
      stageId: "sub_02-01",
      drops: [
        "30052",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "3003",
        "30061",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S2-2": {
      stageId: "sub_02-02",
      drops: [
        "30011",
        "30021",
        "30031",
        "30041",
        "30061",
        "3003",
        "2001",
        "30051",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S2-3": {
      stageId: "sub_02-03",
      drops: [
        "2001",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S2-4": {
      stageId: "sub_02-04",
      drops: [
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S2-5": {
      stageId: "sub_02-05",
      drops: [
        "30011",
        "30011",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "2001",
        "30031",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S2-6": {
      stageId: "sub_02-06",
      drops: [
        "30021",
        "30021",
        "30051",
        "2001",
        "30041",
        "30022",
        "30042",
        "2002",
        "30052",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S2-7": {
      stageId: "sub_02-07",
      drops: [
        "30031",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S2-8": {
      stageId: "sub_02-08",
      drops: [
        "30041",
        "30021",
        "30051",
        "30041",
        "30022",
        "2001",
        "30042",
        "2002",
        "30052",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S2-9": {
      stageId: "sub_02-09",
      drops: [
        "30051",
        "30021",
        "30051",
        "30041",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S2-10": {
      stageId: "sub_02-10",
      drops: [
        "2002",
        "30011",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "2001",
        "30031",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S2-11": {
      stageId: "sub_02-11",
      drops: [
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S2-12": {
      stageId: "sub_02-12",
      drops: [
        "30012",
        "30011",
        "30031",
        "30061",
        "3003",
        "30032",
        "30062",
        "30012",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "3-1": {
      stageId: "main_03-01",
      drops: [
        "30053",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "3-2": {
      stageId: "main_03-02",
      drops: [
        "30083",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "3-3": {
      stageId: "main_03-03",
      drops: [
        "30093",
        "30011",
        "30031",
        "30061",
        "30012",
        "3003",
        "30032",
        "30062",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "3-4": {
      stageId: "main_03-04",
      drops: [
        "30063",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "3-5": {
      stageId: "main_03-05",
      drops: [
        "2002",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "3-6": {
      stageId: "main_03-06",
      drops: [
        "30021",
        "30041",
        "30051",
        "30022",
        "2001",
        "30042",
        "30052",
        "2002",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "3-7": {
      stageId: "main_03-07",
      drops: [
        "30052",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "2002",
        "30052",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "3-8": {
      stageId: "main_03-08",
      drops: [
        "30033",
        "30034",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "30103",
        "30031",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S3-1": {
      stageId: "sub_03-1-1",
      drops: [
        "30022",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S3-2": {
      stageId: "sub_03-1-2",
      drops: [
        "30011",
        "30032",
        "30031",
        "30061",
        "3003",
        "30012",
        "30062",
        "30032",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S3-3": {
      stageId: "sub_03-2-1",
      drops: [
        "30021",
        "30041",
        "30051",
        "30042",
        "2001",
        "30042",
        "30052",
        "30022",
        "2002",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S3-4": {
      stageId: "sub_03-2-2",
      drops: [
        "30062",
        "30011",
        "30031",
        "30061",
        "30012",
        "3003",
        "30032",
        "30062",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S3-5": {
      stageId: "sub_03-2-3",
      drops: [
        "30021",
        "30051",
        "30041",
        "2001",
        "30022",
        "30052",
        "30042",
        "2002",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "4-1": {
      stageId: "main_04-01",
      drops: [
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "4-2": {
      stageId: "main_04-02",
      drops: [
        "30023",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "30024",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "4-3": {
      stageId: "main_04-03",
      drops: [
        "2003",
        "30011",
        "30012",
        "30062",
        "30061",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "4-4": {
      stageId: "main_04-04",
      drops: [
        "30073",
        "30074",
        "30011",
        "30061",
        "30012",
        "30062",
        "30063",
        "30013",
        "31013",
        "3003",
        "30073",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "4-5": {
      stageId: "main_04-05",
      drops: [
        "30053",
        "30054",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30093",
        "30053",
        "30103",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "4-6": {
      stageId: "main_04-06",
      drops: [
        "30013",
        "30014",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "31013",
        "30073",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "4-7": {
      stageId: "main_04-07",
      drops: [
        "30083",
        "30084",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "4-8": {
      stageId: "main_04-08",
      drops: [
        "30093",
        "30094",
        "30051",
        "30031",
        "30032",
        "30033",
        "30052",
        "30053",
        "30093",
        "30103",
        "31033",
        "31043",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "4-9": {
      stageId: "main_04-09",
      drops: [
        "30103",
        "30104",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "30103",
        "31033",
        "31043",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "4-10": {
      stageId: "main_04-10",
      drops: [
        "30063",
        "30064",
        "30011",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "30061",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S4-1": {
      stageId: "sub_04-1-1",
      drops: [
        "30043",
        "30044",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S4-2": {
      stageId: "sub_04-1-2",
      drops: [
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "30103",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S4-3": {
      stageId: "sub_04-1-3",
      drops: [
        "30021",
        "30041",
        "2001",
        "30022",
        "2002",
        "30042",
        "30023",
        "30043",
        "31023",
        "30083",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S4-4": {
      stageId: "sub_04-2-1",
      drops: [
        "30021",
        "30041",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S4-5": {
      stageId: "sub_04-2-2",
      drops: [
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30093",
        "30103",
        "30053",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S4-6": {
      stageId: "sub_04-2-3",
      drops: [
        "30021",
        "2001",
        "30041",
        "30022",
        "2002",
        "30042",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S4-7": {
      stageId: "sub_04-3-1",
      drops: [
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S4-8": {
      stageId: "sub_04-3-2",
      drops: [
        "30031",
        "30032",
        "30052",
        "30051",
        "30033",
        "30093",
        "30103",
        "30053",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S4-9": {
      stageId: "sub_04-3-3",
      drops: [
        "2003",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "GT-1": {
      stageId: "a001_01_perm",
      drops: [
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "30012",
        "2001"
      ],
      existence: true
    },
    "GT-2": {
      stageId: "a001_02_perm",
      drops: [
        "30042",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001"
      ],
      existence: true
    },
    "GT-3": {
      stageId: "a001_03_perm",
      drops: [
        "30011",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "2001"
      ],
      existence: true
    },
    "GT-4": {
      stageId: "a001_04_perm",
      drops: [
        "30021",
        "30021",
        "30041",
        "30051",
        "30022",
        "30042",
        "30052",
        "2002",
        "2001"
      ],
      existence: true
    },
    "GT-5": {
      stageId: "a001_05_perm",
      drops: [
        "30073",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062"
      ],
      existence: true
    },
    "GT-6": {
      stageId: "a001_06_perm",
      drops: [
        "30093",
        "30021",
        "30041",
        "30051",
        "30022",
        "30042",
        "30052",
        "2002",
        "2001"
      ],
      existence: true
    },
    "SK-1": {
      stageId: "wk_armor_1",
      drops: ["3112", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "SK-2": {
      stageId: "wk_armor_2",
      drops: ["3112", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "SK-3": {
      stageId: "wk_armor_3",
      drops: ["3112", "3113", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "SK-4": {
      stageId: "wk_armor_4",
      drops: ["3114", "3113", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "SK-5": {
      stageId: "wk_armor_5",
      drops: ["3114", "3113", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "CA-1": {
      stageId: "wk_fly_1",
      drops: ["3301", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "CA-2": {
      stageId: "wk_fly_2",
      drops: ["3301", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "CA-3": {
      stageId: "wk_fly_3",
      drops: ["3302", "3301", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "CA-4": {
      stageId: "wk_fly_4",
      drops: ["3303", "3302", "3301", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "CA-5": {
      stageId: "wk_fly_5",
      drops: ["3303", "3301", "3302", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "5-1": {
      stageId: "main_05-01",
      drops: [
        "30013",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30073",
        "30063",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "5-2": {
      stageId: "main_05-02",
      drops: [
        "30023",
        "30024",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "5-3": {
      stageId: "main_05-03",
      drops: ["30033", "30022", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "5-4": {
      stageId: "main_05-04",
      drops: [
        "30031",
        "30073",
        "30051",
        "30032",
        "30052",
        "30033",
        "30093",
        "30103",
        "30053",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "5-5": {
      stageId: "main_05-05",
      drops: [
        "30043",
        "30044",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30073",
        "31013",
        "3003",
        "30063",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "5-6": {
      stageId: "main_05-06",
      drops: [
        "30021",
        "30083",
        "2001",
        "30041",
        "30022",
        "2002",
        "30042",
        "30023",
        "30043",
        "30083",
        "2003",
        "31023",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "5-7": {
      stageId: "main_05-07",
      drops: ["30093", "30042", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "5-8": {
      stageId: "main_05-08",
      drops: [
        "30053",
        "30054",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "30103",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "5-9": {
      stageId: "main_05-09",
      drops: [
        "30103",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "5-10": {
      stageId: "main_05-10",
      drops: ["30063", "30012", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "S5-1": {
      stageId: "sub_05-1-1",
      drops: ["2003", "30012", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "S5-2": {
      stageId: "sub_05-1-2",
      drops: [
        "30021",
        "30041",
        "2001",
        "30042",
        "2002",
        "30023",
        "30022",
        "30043",
        "31023",
        "2003",
        "30083",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S5-3": {
      stageId: "sub_05-2-1",
      drops: ["30032", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "S5-4": {
      stageId: "sub_05-2-2",
      drops: ["2003", "30022", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "S5-5": {
      stageId: "sub_05-3-1",
      drops: ["30062", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "S5-6": {
      stageId: "sub_05-3-2",
      drops: [
        "2003",
        "30041",
        "2001",
        "30021",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "OF-1": {
      stageId: "a003_01",
      drops: [],
      existence: true
    },
    "OF-2": {
      stageId: "a003_02",
      drops: [],
      existence: true
    },
    "OF-3": {
      stageId: "a003_03",
      drops: [],
      existence: true
    },
    "OF-4": {
      stageId: "a003_04",
      drops: [],
      existence: true
    },
    "OF-5": {
      stageId: "a003_05",
      drops: [],
      existence: true
    },
    "OF-6": {
      stageId: "a003_06",
      drops: [],
      existence: true
    },
    "OF-7": {
      stageId: "a003_07",
      drops: [],
      existence: true
    },
    "OF-8": {
      stageId: "a003_08",
      drops: [],
      existence: true
    },
    "OF-F1": {
      stageId: "a003_f01_perm",
      drops: [
        "30022",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001"
      ],
      existence: true
    },
    "OF-F2": {
      stageId: "a003_f02_perm",
      drops: [
        "30031",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "2001"
      ],
      existence: true
    },
    "OF-F3": {
      stageId: "a003_f03_perm",
      drops: [
        "30023",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062"
      ],
      existence: true
    },
    "OF-F4": {
      stageId: "a003_f04_perm",
      drops: [
        "30083",
        "30084",
        "30021",
        "30041",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "2001"
      ],
      existence: true
    },
    奖励扭蛋机: {
      stageId: "gachabox6",
      drops: [],
      existence: true
    },
    "SW-EV-1": {
      stageId: "act4d0_01",
      drops: [],
      existence: true
    },
    "SW-EV-2": {
      stageId: "act4d0_02",
      drops: [],
      existence: true
    },
    "SW-EV-3": {
      stageId: "act4d0_03",
      drops: [],
      existence: true
    },
    "SW-EV-4": {
      stageId: "act4d0_04",
      drops: [],
      existence: true
    },
    "SW-EV-5": {
      stageId: "act4d0_05",
      drops: [],
      existence: true
    },
    "CB-1": {
      stageId: "act5d0_01_rep",
      drops: [],
      existence: true
    },
    "CB-2": {
      stageId: "act5d0_02_rep",
      drops: [],
      existence: true
    },
    "CB-3": {
      stageId: "act5d0_03_rep",
      drops: [],
      existence: true
    },
    "CB-4": {
      stageId: "act5d0_04_rep",
      drops: [],
      existence: true
    },
    "CB-5": {
      stageId: "act5d0_05_rep",
      drops: [],
      existence: true
    },
    "CB-6": {
      stageId: "act5d0_06_rep",
      drops: [],
      existence: true
    },
    "CB-7": {
      stageId: "act5d0_07_rep",
      drops: [],
      existence: true
    },
    "CB-8": {
      stageId: "act5d0_08_rep",
      drops: [],
      existence: true
    },
    "CB-9": {
      stageId: "act5d0_09_rep",
      drops: [],
      existence: true
    },
    "CB-10": {
      stageId: "act5d0_10_rep",
      drops: [],
      existence: true
    },
    "6-1": {
      stageId: "main_06-01",
      drops: ["30042", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "6-2": {
      stageId: "main_06-02",
      drops: [
        "30083",
        "30031",
        "30051",
        "30032",
        "30052",
        "30084",
        "30053",
        "30033",
        "30093",
        "30103",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "6-3": {
      stageId: "main_06-03",
      drops: [
        "30023",
        "30011",
        "30061",
        "30062",
        "30013",
        "30063",
        "30073",
        "30012",
        "3003",
        "31013",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "6-4": {
      stageId: "main_06-04",
      drops: [
        "30033",
        "30034",
        "30031",
        "30051",
        "30032",
        "30033",
        "30053",
        "30093",
        "30103",
        "30052",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "6-5": {
      stageId: "main_06-05",
      drops: ["30013", "30032", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "6-7": {
      stageId: "main_06-06",
      drops: [],
      existence: true
    },
    "6-8": {
      stageId: "main_06-07",
      drops: [
        "30053",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30083",
        "31023",
        "2003",
        "30043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "6-9": {
      stageId: "main_06-08",
      drops: ["30032", "2003", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "6-10": {
      stageId: "main_06-09",
      drops: [
        "30043",
        "30031",
        "30051",
        "30052",
        "30032",
        "30033",
        "30053",
        "30093",
        "30103",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "6-11": {
      stageId: "main_06-10",
      drops: ["30073", "30062", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "6-12": {
      stageId: "main_06-11",
      drops: [
        "31023",
        "31024",
        "30021",
        "30041",
        "2001",
        "30022",
        "2002",
        "30042",
        "30043",
        "30083",
        "31023",
        "2003",
        "30023",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "6-14": {
      stageId: "main_06-12",
      drops: [
        "30011",
        "30093",
        "30061",
        "30012",
        "30062",
        "30013",
        "30073",
        "30063",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "6-15": {
      stageId: "main_06-13",
      drops: [
        "30103",
        "30104",
        "30031",
        "30051",
        "30032",
        "30052",
        "30053",
        "30093",
        "30103",
        "30033",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "6-16": {
      stageId: "main_06-14",
      drops: ["30063", "30052", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "6-17": {
      stageId: "main_06-15",
      drops: [],
      existence: true
    },
    "S3-6": {
      stageId: "sub_03-3-1",
      drops: [
        "31023",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S4-10": {
      stageId: "sub_04-4-1",
      drops: [
        "31013",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S5-7": {
      stageId: "sub_05-4-1",
      drops: [
        "31013",
        "31014",
        "30051",
        "30032",
        "30031",
        "30052",
        "30033",
        "30053",
        "30093",
        "30103",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S5-8": {
      stageId: "sub_05-4-2",
      drops: [
        "31023",
        "31024",
        "30011",
        "30012",
        "30061",
        "30062",
        "30063",
        "30013",
        "30073",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S6-1": {
      stageId: "sub_06-1-1",
      drops: [
        "2003",
        "30031",
        "30032",
        "30051",
        "30052",
        "30033",
        "30053",
        "30103",
        "30093",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S6-2": {
      stageId: "sub_06-1-2",
      drops: ["30012", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "S6-3": {
      stageId: "sub_06-2-1",
      drops: ["30052", "2003", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "S6-4": {
      stageId: "sub_06-2-2",
      drops: [
        "30051",
        "30032",
        "30031",
        "30052",
        "30033",
        "30093",
        "30103",
        "30053",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    罗德岛物资补给: {
      stageId: "randomMaterial_1",
      drops: [
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "30012",
        "30022",
        "30032",
        "30042",
        "30052",
        "30062",
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023"
      ],
      existence: true
    },
    "AF-1": {
      stageId: "act6d5_01",
      drops: [],
      existence: true
    },
    "AF-2": {
      stageId: "act6d5_02",
      drops: [],
      existence: true
    },
    "AF-3": {
      stageId: "act6d5_03",
      drops: [],
      existence: true
    },
    "AF-4": {
      stageId: "act6d5_04",
      drops: [],
      existence: true
    },
    "AF-5": {
      stageId: "act6d5_05",
      drops: [],
      existence: true
    },
    "AF-6": {
      stageId: "act6d5_06",
      drops: [],
      existence: true
    },
    "AF-7": {
      stageId: "act6d5_07",
      drops: [],
      existence: true
    },
    "AF-8": {
      stageId: "act6d5_08",
      drops: [],
      existence: true
    },
    岁过华灯: {
      stageId: "randomMaterial_2",
      drops: [
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "30012",
        "30022",
        "30032",
        "30042",
        "30052",
        "30062",
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023"
      ],
      existence: true
    },
    "CE-1": {
      stageId: "wk_melee_1",
      drops: ["ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "CE-2": {
      stageId: "wk_melee_2",
      drops: ["ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "CE-3": {
      stageId: "wk_melee_3",
      drops: ["ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "CE-4": {
      stageId: "wk_melee_4",
      drops: ["ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "CE-5": {
      stageId: "wk_melee_5",
      drops: ["ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "AP-1": {
      stageId: "wk_toxic_1",
      drops: ["ap_supply_lt_010", "randomMaterial_6", "4006"],
      existence: true
    },
    "AP-2": {
      stageId: "wk_toxic_2",
      drops: ["ap_supply_lt_010", "randomMaterial_6", "4006"],
      existence: true
    },
    "AP-3": {
      stageId: "wk_toxic_3",
      drops: ["ap_supply_lt_010", "randomMaterial_6", "4006"],
      existence: true
    },
    "AP-4": {
      stageId: "wk_toxic_4",
      drops: ["ap_supply_lt_010", "randomMaterial_6", "4006"],
      existence: true
    },
    "AP-5": {
      stageId: "wk_toxic_5",
      drops: ["ap_supply_lt_010", "randomMaterial_6", "4006"],
      existence: true
    },
    "SA-1": {
      stageId: "act7d5_01",
      drops: [],
      existence: true
    },
    "SA-2": {
      stageId: "act7d5_02",
      drops: [],
      existence: true
    },
    "SA-3": {
      stageId: "act7d5_03",
      drops: [],
      existence: true
    },
    "SA-4": {
      stageId: "act7d5_04",
      drops: [],
      existence: true
    },
    "SA-5": {
      stageId: "act7d5_05",
      drops: [],
      existence: true
    },
    "SA-6": {
      stageId: "act7d5_06",
      drops: [],
      existence: true
    },
    荒芜行动物资补给: {
      stageId: "randomMaterialRune_0",
      drops: [
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023"
      ],
      existence: true
    },
    "DM-1": {
      stageId: "act9d0_01_perm",
      drops: [
        "30032",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001"
      ],
      existence: true
    },
    "DM-2": {
      stageId: "act9d0_02_perm",
      drops: [
        "30052",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001"
      ],
      existence: true
    },
    "DM-3": {
      stageId: "act9d0_03_perm",
      drops: [
        "30031",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "2001"
      ],
      existence: true
    },
    "DM-4": {
      stageId: "act9d0_04_perm",
      drops: [
        "30041",
        "30021",
        "30041",
        "30051",
        "30022",
        "30042",
        "30052",
        "2002",
        "2001"
      ],
      existence: true
    },
    "DM-5": {
      stageId: "act9d0_05_perm",
      drops: [
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "30012"
      ],
      existence: true
    },
    "DM-6": {
      stageId: "act9d0_06_perm",
      drops: [
        "30023",
        "30021",
        "30041",
        "30051",
        "30022",
        "30042",
        "30052",
        "2002",
        "2001"
      ],
      existence: true
    },
    "DM-7": {
      stageId: "act9d0_07_perm",
      drops: [
        "30073",
        "30074",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103"
      ],
      existence: true
    },
    "DM-8": {
      stageId: "act9d0_08_perm",
      drops: [
        "30043",
        "30044",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003"
      ],
      existence: true
    },
    "7-2": {
      stageId: "main_07-01",
      drops: [
        "30013",
        "30014",
        "30031",
        "30051",
        "30032",
        "30033",
        "30052",
        "30053",
        "30093",
        "30103",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "7-3": {
      stageId: "main_07-02",
      drops: ["30022", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "7-4": {
      stageId: "main_07-03",
      drops: [
        "30033",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "7-5": {
      stageId: "main_07-04",
      drops: [
        "30073",
        "30074",
        "30031",
        "30051",
        "30052",
        "30032",
        "30033",
        "30093",
        "30053",
        "30103",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "7-6": {
      stageId: "main_07-05",
      drops: ["30013", "30022", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "7-8": {
      stageId: "main_07-06",
      drops: [
        "31013",
        "31014",
        "30021",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "30041",
        "2003",
        "31023",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "7-9": {
      stageId: "main_07-07",
      drops: [
        "30063",
        "30064",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "30103",
        "31033",
        "31043",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "7-10": {
      stageId: "main_07-08",
      drops: [
        "30103",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "30103",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "7-11": {
      stageId: "main_07-09",
      drops: ["30042", "2003", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "7-12": {
      stageId: "main_07-10",
      drops: ["30023", "30052", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "7-13": {
      stageId: "main_07-11",
      drops: [
        "30011",
        "2003",
        "30061",
        "30062",
        "30013",
        "30012",
        "30063",
        "31013",
        "30073",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "7-14": {
      stageId: "main_07-12",
      drops: [
        "30053",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30093",
        "30053",
        "30103",
        "31033",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "7-15": {
      stageId: "main_07-13",
      drops: [
        "30063",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "31023",
        "30083",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "7-16": {
      stageId: "main_07-14",
      drops: ["30083", "30012", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "7-17": {
      stageId: "main_07-15",
      drops: [
        "30093",
        "30094",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "7-18": {
      stageId: "main_07-16",
      drops: ["30043", "30052", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "S7-1": {
      stageId: "sub_07-1-1",
      drops: [
        "30011",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "30061",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S7-2": {
      stageId: "sub_07-1-2",
      drops: ["30052", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "32h战略配给": {
      stageId: "randomMaterial_3",
      drops: [
        "30012",
        "30022",
        "30032",
        "30042",
        "30052",
        "30062",
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023"
      ],
      existence: true
    },
    "PR-A-1": {
      stageId: "pro_a_1",
      drops: ["3231", "3261", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "PR-A-2": {
      stageId: "pro_a_2",
      drops: ["3232", "3262", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "PR-B-1": {
      stageId: "pro_b_1",
      drops: ["3241", "3251", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "PR-B-2": {
      stageId: "pro_b_2",
      drops: ["3242", "3252", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "PR-C-1": {
      stageId: "pro_c_1",
      drops: ["3211", "3271", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "PR-C-2": {
      stageId: "pro_c_2",
      drops: ["3212", "3272", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "PR-D-1": {
      stageId: "pro_d_1",
      drops: ["3221", "3281", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "PR-D-2": {
      stageId: "pro_d_2",
      drops: ["3222", "3282", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "LS-1": {
      stageId: "wk_kc_1",
      drops: ["2002", "2001", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "LS-2": {
      stageId: "wk_kc_2",
      drops: ["2002", "2001", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "LS-3": {
      stageId: "wk_kc_3",
      drops: ["2003", "2002", "2001", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "LS-4": {
      stageId: "wk_kc_4",
      drops: [
        "2004",
        "2003",
        "2002",
        "2001",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "LS-5": {
      stageId: "wk_kc_5",
      drops: ["2004", "2003", "2002", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    黄铁行动物资补给: {
      stageId: "randomMaterialRune_1",
      drops: [
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023"
      ],
      existence: true
    },
    "SV-1": {
      stageId: "act18d3_01_perm",
      drops: [
        "30011",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002"
      ],
      existence: true
    },
    "SV-2": {
      stageId: "act18d3_02_perm",
      drops: [
        "30021",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "2001"
      ],
      existence: true
    },
    "SV-3": {
      stageId: "act18d3_03_perm",
      drops: [
        "30031",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002"
      ],
      existence: true
    },
    "SV-4": {
      stageId: "act18d3_04_perm",
      drops: [
        "30041",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "2001"
      ],
      existence: true
    },
    "SV-5": {
      stageId: "act18d3_05_perm",
      drops: [
        "30051",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002"
      ],
      existence: true
    },
    "SV-6": {
      stageId: "act18d3_06_perm",
      drops: [
        "30061",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "2001"
      ],
      existence: true
    },
    "SV-7": {
      stageId: "act18d3_07_perm",
      drops: [
        "30013",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002"
      ],
      existence: true
    },
    "TW-1": {
      stageId: "act11d0_01_perm",
      drops: [
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "30012"
      ],
      existence: true
    },
    "TW-2": {
      stageId: "act11d0_02_perm",
      drops: [
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "30042"
      ],
      existence: true
    },
    "TW-3": {
      stageId: "act11d0_03_perm",
      drops: [
        "2002",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002"
      ],
      existence: true
    },
    "TW-4": {
      stageId: "act11d0_04_perm",
      drops: [
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "2001"
      ],
      existence: true
    },
    "TW-5": {
      stageId: "act11d0_05_perm",
      drops: [
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "30062"
      ],
      existence: true
    },
    "TW-6": {
      stageId: "act11d0_06_perm",
      drops: [
        "31023",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002"
      ],
      existence: true
    },
    "TW-7": {
      stageId: "act11d0_07_perm",
      drops: [
        "30053",
        "30054",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103"
      ],
      existence: true
    },
    "TW-8": {
      stageId: "act11d0_08_perm",
      drops: [
        "30093",
        "30094",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003"
      ],
      existence: true
    },
    利刃行动物资补给: {
      stageId: "randomMaterialRune_2",
      drops: [
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023"
      ],
      existence: true
    },
    "RI-1": {
      stageId: "act12d0_01_perm",
      drops: [
        "30022",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001"
      ],
      existence: true
    },
    "RI-2": {
      stageId: "act12d0_02_perm",
      drops: [
        "30032",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001"
      ],
      existence: true
    },
    "RI-3": {
      stageId: "act12d0_03_perm",
      drops: [
        "30011",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "2001"
      ],
      existence: true
    },
    "RI-4": {
      stageId: "act12d0_04_perm",
      drops: [
        "30021",
        "30021",
        "30041",
        "30051",
        "30022",
        "30042",
        "30052",
        "2002",
        "2001"
      ],
      existence: true
    },
    "RI-5": {
      stageId: "act12d0_05_perm",
      drops: [
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "30042"
      ],
      existence: true
    },
    "RI-6": {
      stageId: "act12d0_06_perm",
      drops: [
        "30013",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002"
      ],
      existence: true
    },
    "RI-7": {
      stageId: "act12d0_07_perm",
      drops: [
        "30023",
        "30024",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003"
      ],
      existence: true
    },
    "RI-8": {
      stageId: "act12d0_08_perm",
      drops: [
        "30103",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103"
      ],
      existence: true
    },
    "FA-1": {
      stageId: "act13d0_01",
      drops: [],
      existence: true
    },
    "FA-2": {
      stageId: "act13d0_02",
      drops: [],
      existence: true
    },
    "FA-3": {
      stageId: "act13d0_03",
      drops: [],
      existence: true
    },
    "FA-4": {
      stageId: "act13d0_04",
      drops: [],
      existence: true
    },
    "FA-5": {
      stageId: "act13d0_05",
      drops: [],
      existence: true
    },
    "FA-6": {
      stageId: "act13d0_06",
      drops: [],
      existence: true
    },
    "FA-7": {
      stageId: "act13d0_07",
      drops: [],
      existence: true
    },
    "FA-8": {
      stageId: "act13d0_08",
      drops: [],
      existence: true
    },
    "MN-1": {
      stageId: "act13d5_01_perm",
      drops: [
        "30052",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001"
      ],
      existence: true
    },
    "MN-2": {
      stageId: "act13d5_02_perm",
      drops: [
        "30012",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "2001"
      ],
      existence: true
    },
    "MN-3": {
      stageId: "act13d5_03_perm",
      drops: [
        "30031",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "2001"
      ],
      existence: true
    },
    "MN-4": {
      stageId: "act13d5_04_perm",
      drops: [
        "30041",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002"
      ],
      existence: true
    },
    "MN-5": {
      stageId: "act13d5_05_perm",
      drops: [
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "30052"
      ],
      existence: true
    },
    "MN-6": {
      stageId: "act13d5_06_perm",
      drops: [
        "31013",
        "31014",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002"
      ],
      existence: true
    },
    "MN-7": {
      stageId: "act13d5_07_perm",
      drops: [
        "30033",
        "30034",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003"
      ],
      existence: true
    },
    "MN-8": {
      stageId: "act13d5_08_perm",
      drops: [
        "30083",
        "30084",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103"
      ],
      existence: true
    },
    "S5-9": {
      stageId: "sub_05-4-3",
      drops: [
        "31033",
        "31034",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S3-7": {
      stageId: "sub_03-3-2",
      drops: ["31033", "30012", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "R8-1": {
      stageId: "main_08-01",
      drops: [
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "R8-2": {
      stageId: "main_08-02",
      drops: [
        "30073",
        "30074",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "R8-3": {
      stageId: "main_08-03",
      drops: [
        "30013",
        "30014",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "R8-4": {
      stageId: "main_08-04",
      drops: ["30032", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "R8-5": {
      stageId: "main_08-05",
      drops: ["2003", "30022", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "R8-6": {
      stageId: "main_08-06",
      drops: [
        "2003",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "R8-7": {
      stageId: "main_08-07",
      drops: [
        "31023",
        "31024",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "R8-8": {
      stageId: "main_08-08",
      drops: ["31013", "30052", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "M8-6": {
      stageId: "main_08-09",
      drops: ["2003", "30062", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "R8-9": {
      stageId: "main_08-10",
      drops: [
        "30103",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "R8-10": {
      stageId: "main_08-11",
      drops: [
        "30083",
        "30084",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "M8-7": {
      stageId: "main_08-12",
      drops: ["30023", "30042", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "R8-11": {
      stageId: "main_08-13",
      drops: [
        "31033",
        "31034",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "M8-8": {
      stageId: "main_08-14",
      drops: [
        "30063",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "JT8-1": {
      stageId: "main_08-15",
      drops: [],
      existence: true
    },
    "JT8-2": {
      stageId: "main_08-16",
      drops: [
        "31013",
        "31014",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103",
        "31043",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "JT8-3": {
      stageId: "main_08-17",
      drops: [
        "30053",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    感谢庆典物资补给: {
      stageId: "randomMaterial_4",
      drops: [
        "30012",
        "30022",
        "30032",
        "30042",
        "30052",
        "30062",
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023",
        "31033"
      ],
      existence: true
    },
    燃灰行动物资补给: {
      stageId: "randomMaterialRune_3",
      drops: [
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023"
      ],
      existence: true
    },
    "MB-1": {
      stageId: "act15d0_01_perm",
      drops: [
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "30042"
      ],
      existence: true
    },
    "MB-2": {
      stageId: "act15d0_02_perm",
      drops: [
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003",
        "30022"
      ],
      existence: true
    },
    "MB-3": {
      stageId: "act15d0_03_perm",
      drops: [
        "30051",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062"
      ],
      existence: true
    },
    "MB-4": {
      stageId: "act15d0_04_perm",
      drops: [
        "30061",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002"
      ],
      existence: true
    },
    "MB-5": {
      stageId: "act15d0_05_perm",
      drops: [
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062",
        "30052"
      ],
      existence: true
    },
    "MB-6": {
      stageId: "act15d0_06_perm",
      drops: [
        "30023",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002"
      ],
      existence: true
    },
    "MB-7": {
      stageId: "act15d0_07_perm",
      drops: [
        "30053",
        "30054",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003"
      ],
      existence: true
    },
    "MB-8": {
      stageId: "act15d0_08_perm",
      drops: [
        "30043",
        "30044",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003"
      ],
      existence: true
    },
    "BH-1": {
      stageId: "act15d5_01",
      drops: [],
      existence: true
    },
    "BH-2": {
      stageId: "act15d5_02",
      drops: [],
      existence: true
    },
    "BH-3": {
      stageId: "act15d5_03",
      drops: [],
      existence: true
    },
    "BH-4": {
      stageId: "act15d5_04",
      drops: [],
      existence: true
    },
    "BH-5": {
      stageId: "act15d5_05",
      drops: [],
      existence: true
    },
    "BH-6": {
      stageId: "act15d5_06",
      drops: [],
      existence: true
    },
    "BH-7": {
      stageId: "act15d5_07",
      drops: [],
      existence: true
    },
    "BH-8": {
      stageId: "act15d5_08",
      drops: [],
      existence: true
    },
    铅封行动物资补给: {
      stageId: "randomMaterialRune_4",
      drops: [
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023"
      ],
      existence: true
    },
    "WR-1": {
      stageId: "act16d5_01_perm",
      drops: [
        "30032",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003"
      ],
      existence: true
    },
    "WR-2": {
      stageId: "act16d5_02_perm",
      drops: [
        "30052",
        "30011",
        "30021",
        "30031",
        "30041",
        "30051",
        "30061",
        "3003"
      ],
      existence: true
    },
    "WR-3": {
      stageId: "act16d5_03_perm",
      drops: [
        "2002",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062"
      ],
      existence: true
    },
    "WR-4": {
      stageId: "act16d5_04_perm",
      drops: [
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002"
      ],
      existence: true
    },
    "WR-5": {
      stageId: "act16d5_05_perm",
      drops: [
        "30021",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062"
      ],
      existence: true
    },
    "WR-6": {
      stageId: "act16d5_06_perm",
      drops: [
        "30031",
        "30021",
        "30041",
        "30051",
        "2001",
        "30022",
        "30042",
        "30052",
        "2002"
      ],
      existence: true
    },
    "WR-7": {
      stageId: "act16d5_07_perm",
      drops: [
        "30041",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062"
      ],
      existence: true
    },
    "WR-8": {
      stageId: "act16d5_08_perm",
      drops: [
        "31023",
        "30011",
        "30031",
        "30061",
        "3003",
        "30012",
        "30032",
        "30062"
      ],
      existence: true
    },
    "WR-9": {
      stageId: "act16d5_09_perm",
      drops: [
        "30033",
        "30034",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103"
      ],
      existence: true
    },
    "WR-10": {
      stageId: "act16d5_10_perm",
      drops: [
        "30013",
        "30014",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003"
      ],
      existence: true
    },
    "OD-1": {
      stageId: "act17d0_01",
      drops: [],
      existence: true
    },
    "OD-2": {
      stageId: "act17d0_02",
      drops: [],
      existence: true
    },
    "OD-3": {
      stageId: "act17d0_03",
      drops: [],
      existence: true
    },
    "OD-4": {
      stageId: "act17d0_04",
      drops: [],
      existence: true
    },
    "OD-5": {
      stageId: "act17d0_05",
      drops: [],
      existence: true
    },
    "OD-6": {
      stageId: "act17d0_06",
      drops: [],
      existence: true
    },
    "OD-7": {
      stageId: "act17d0_07",
      drops: [],
      existence: true
    },
    "OD-8": {
      stageId: "act17d0_08",
      drops: [],
      existence: true
    },
    "WD-1": {
      stageId: "act18d0_01_rep",
      drops: [],
      existence: true
    },
    "WD-2": {
      stageId: "act18d0_02_rep",
      drops: [],
      existence: true
    },
    "WD-3": {
      stageId: "act18d0_03_rep",
      drops: [],
      existence: true
    },
    "WD-4": {
      stageId: "act18d0_04_rep",
      drops: [],
      existence: true
    },
    "WD-5": {
      stageId: "act18d0_05_rep",
      drops: [],
      existence: true
    },
    "WD-6": {
      stageId: "act18d0_06_rep",
      drops: [],
      existence: true
    },
    "WD-7": {
      stageId: "act18d0_07_rep",
      drops: [],
      existence: true
    },
    "WD-8": {
      stageId: "act18d0_08_rep",
      drops: [],
      existence: true
    },
    "SV-8": {
      stageId: "act18d3_08_perm",
      drops: [
        "31033",
        "31034",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003"
      ],
      existence: true
    },
    "SV-9": {
      stageId: "act18d3_09_perm",
      drops: [
        "30063",
        "30064",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003"
      ],
      existence: true
    },
    光谱行动物资补给: {
      stageId: "randomMaterialRune_5",
      drops: [
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023"
      ],
      existence: true
    },
    "PL-1": {
      stageId: "act7mini_01",
      drops: [],
      existence: true
    },
    "PL-2": {
      stageId: "act7mini_02",
      drops: [],
      existence: true
    },
    "PL-3": {
      stageId: "act7mini_03",
      drops: [],
      existence: true
    },
    "PL-4": {
      stageId: "act7mini_04",
      drops: [],
      existence: true
    },
    "PL-5": {
      stageId: "act7mini_05",
      drops: [],
      existence: true
    },
    "VI-1": {
      stageId: "act8mini_01",
      drops: [],
      existence: true
    },
    "VI-2": {
      stageId: "act8mini_02",
      drops: [],
      existence: true
    },
    "VI-3": {
      stageId: "act8mini_03",
      drops: [],
      existence: true
    },
    "VI-4": {
      stageId: "act8mini_04",
      drops: [],
      existence: true
    },
    "VI-5": {
      stageId: "act8mini_05",
      drops: [],
      existence: true
    },
    "VI-6": {
      stageId: "act8mini_06",
      drops: [],
      existence: true
    },
    "VI-7": {
      stageId: "act8mini_07",
      drops: [],
      existence: true
    },
    "DH-1": {
      stageId: "act12side_01",
      drops: [],
      existence: true
    },
    "DH-2": {
      stageId: "act12side_02",
      drops: [],
      existence: true
    },
    "DH-3": {
      stageId: "act12side_03",
      drops: [],
      existence: true
    },
    "DH-4": {
      stageId: "act12side_04",
      drops: [],
      existence: true
    },
    "DH-5": {
      stageId: "act12side_05",
      drops: [],
      existence: true
    },
    "DH-6": {
      stageId: "act12side_06",
      drops: [],
      existence: true
    },
    "DH-7": {
      stageId: "act12side_07",
      drops: [],
      existence: true
    },
    "DH-8": {
      stageId: "act12side_08",
      drops: [],
      existence: true
    },
    "DH-9": {
      stageId: "act12side_09",
      drops: [],
      existence: true
    },
    "RI-9": {
      stageId: "act12d0_09_perm",
      drops: [
        "30033",
        "30034",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003"
      ],
      existence: true
    },
    蛮鳞行动物资补给: {
      stageId: "randomMaterialRune_6",
      drops: [
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023",
        "31033"
      ],
      existence: true
    },
    "9-2": {
      stageId: "main_09-01",
      drops: [
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "9-3": {
      stageId: "main_09-02",
      drops: ["30062", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "9-4": {
      stageId: "main_09-03",
      drops: [
        "31043",
        "31044",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "9-5": {
      stageId: "main_09-04",
      drops: [
        "30023",
        "30024",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "9-6": {
      stageId: "main_09-05",
      drops: [
        "31053",
        "31054",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "9-7": {
      stageId: "main_09-06",
      drops: [
        "30033",
        "30034",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "9-9": {
      stageId: "main_09-07",
      drops: [
        "30073",
        "30074",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "9-10": {
      stageId: "main_09-08",
      drops: [
        "30063",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "9-11": {
      stageId: "main_09-09",
      drops: [
        "2003",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "9-12": {
      stageId: "main_09-10",
      drops: [
        "31023",
        "31024",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "9-13": {
      stageId: "main_09-11",
      drops: [
        "30013",
        "30014",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "9-14": {
      stageId: "main_09-12",
      drops: [
        "31033",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "9-15": {
      stageId: "main_09-13",
      drops: [
        "30083",
        "30084",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "9-16": {
      stageId: "main_09-14",
      drops: ["30093", "30042", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "9-17": {
      stageId: "main_09-15",
      drops: [
        "30043",
        "30044",
        "30011",
        "30061",
        "30012",
        "30062",
        "30013",
        "30063",
        "30073",
        "31013",
        "3003",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "9-18": {
      stageId: "main_09-16",
      drops: [
        "31043",
        "31044",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "9-19": {
      stageId: "main_09-17",
      drops: [
        "30103",
        "30031",
        "30051",
        "30032",
        "30052",
        "30033",
        "30053",
        "30093",
        "31033",
        "30103",
        "31053",
        "31043",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "S9-1": {
      stageId: "sub_09-1-1",
      drops: [
        "30053",
        "30054",
        "30021",
        "30041",
        "2001",
        "30022",
        "30042",
        "2002",
        "30023",
        "30043",
        "30083",
        "31023",
        "2003",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    罗德岛物资补给II: {
      stageId: "randomMaterial_5",
      drops: [
        "30012",
        "30022",
        "30032",
        "30042",
        "30052",
        "30062",
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023",
        "31033",
        "31043",
        "31053"
      ],
      existence: true
    },
    "PS-1": {
      stageId: "act9mini_01",
      drops: [],
      existence: true
    },
    "PS-2": {
      stageId: "act9mini_02",
      drops: [],
      existence: true
    },
    "PS-3": {
      stageId: "act9mini_03",
      drops: [],
      existence: true
    },
    "PS-4": {
      stageId: "act9mini_04",
      drops: [],
      existence: true
    },
    "PS-5": {
      stageId: "act9mini_05",
      drops: [],
      existence: true
    },
    "PS-6": {
      stageId: "act9mini_06",
      drops: [],
      existence: true
    },
    "NL-1": {
      stageId: "act13side_01",
      drops: [],
      existence: true
    },
    "NL-2": {
      stageId: "act13side_02",
      drops: [],
      existence: true
    },
    "NL-3": {
      stageId: "act13side_03",
      drops: [],
      existence: true
    },
    "NL-4": {
      stageId: "act13side_04",
      drops: [],
      existence: true
    },
    "NL-5": {
      stageId: "act13side_05",
      drops: [],
      existence: true
    },
    "NL-6": {
      stageId: "act13side_06",
      drops: [],
      existence: true
    },
    "NL-7": {
      stageId: "act13side_07",
      drops: [],
      existence: true
    },
    "NL-8": {
      stageId: "act13side_08",
      drops: [],
      existence: true
    },
    "NL-9": {
      stageId: "act13side_09",
      drops: [],
      existence: true
    },
    "NL-10": {
      stageId: "act13side_10",
      drops: [],
      existence: true
    },
    松烟行动物资补给: {
      stageId: "randomMaterialRune_7",
      drops: [
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023",
        "31033",
        "31043",
        "31053"
      ],
      existence: true
    },
    "BI-1": {
      stageId: "act14side_01",
      drops: [],
      existence: true
    },
    "BI-2": {
      stageId: "act14side_02",
      drops: [],
      existence: true
    },
    "BI-3": {
      stageId: "act14side_03",
      drops: [],
      existence: true
    },
    "BI-4": {
      stageId: "act14side_04",
      drops: [],
      existence: true
    },
    "BI-5": {
      stageId: "act14side_05",
      drops: [],
      existence: true
    },
    "BI-6": {
      stageId: "act14side_06",
      drops: [],
      existence: true
    },
    "BI-7": {
      stageId: "act14side_07",
      drops: [],
      existence: true
    },
    "BI-8": {
      stageId: "act14side_08",
      drops: [],
      existence: true
    },
    "IW-1": {
      stageId: "act15side_01",
      drops: [],
      existence: true
    },
    "IW-2": {
      stageId: "act15side_02",
      drops: [],
      existence: true
    },
    "IW-3": {
      stageId: "act15side_03",
      drops: [],
      existence: true
    },
    "IW-4": {
      stageId: "act15side_04",
      drops: [],
      existence: true
    },
    "IW-5": {
      stageId: "act15side_05",
      drops: [],
      existence: true
    },
    "IW-6": {
      stageId: "act15side_06",
      drops: [],
      existence: true
    },
    "IW-7": {
      stageId: "act15side_07",
      drops: [],
      existence: true
    },
    "IW-8": {
      stageId: "act15side_08",
      drops: [],
      existence: true
    },
    "IW-9": {
      stageId: "act15side_09",
      drops: [],
      existence: true
    },
    "TB-1": {
      stageId: "act10mini_01",
      drops: [],
      existence: true
    },
    "TB-2": {
      stageId: "act10mini_02",
      drops: [],
      existence: true
    },
    "TB-3": {
      stageId: "act10mini_03",
      drops: [],
      existence: true
    },
    "TB-4": {
      stageId: "act10mini_04",
      drops: [],
      existence: true
    },
    "TB-5": {
      stageId: "act10mini_05",
      drops: [],
      existence: true
    },
    "TB-6": {
      stageId: "act10mini_06",
      drops: [],
      existence: true
    },
    "TB-7": {
      stageId: "act10mini_07",
      drops: [],
      existence: true
    },
    "TB-8": {
      stageId: "act10mini_08",
      drops: [],
      existence: true
    },
    "TB-9": {
      stageId: "act10mini_09",
      drops: [],
      existence: true
    },
    "TB-10": {
      stageId: "act10mini_10",
      drops: [],
      existence: true
    },
    寻昼行动物资补给: {
      stageId: "randomMaterialRune_8",
      drops: [
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023",
        "31033",
        "31043",
        "31053"
      ],
      existence: true
    },
    "GA-1": {
      stageId: "act16side_01",
      drops: [],
      existence: true
    },
    "GA-2": {
      stageId: "act16side_02",
      drops: [],
      existence: true
    },
    "GA-3": {
      stageId: "act16side_03",
      drops: [],
      existence: true
    },
    "GA-4": {
      stageId: "act16side_04",
      drops: [],
      existence: true
    },
    "GA-5": {
      stageId: "act16side_05",
      drops: [],
      existence: true
    },
    "GA-6": {
      stageId: "act16side_06",
      drops: [],
      existence: true
    },
    "GA-7": {
      stageId: "act16side_07",
      drops: [],
      existence: true
    },
    "GA-8": {
      stageId: "act16side_08",
      drops: [],
      existence: true
    },
    "10-2": {
      stageId: "main_10-01",
      drops: [
        "2003",
        "3003",
        "30011",
        "30012",
        "30013",
        "30061",
        "30062",
        "30063",
        "30073",
        "31013",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "10-3": {
      stageId: "main_10-02",
      drops: [
        "31013",
        "31014",
        "2001",
        "2002",
        "2003",
        "30021",
        "30022",
        "30023",
        "30041",
        "30042",
        "30043",
        "30083",
        "31023",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "10-4": {
      stageId: "main_10-03",
      drops: ["30062", "30053", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "10-5": {
      stageId: "tough_10-04",
      drops: [
        "30103",
        "30104",
        "30031",
        "30032",
        "30033",
        "30051",
        "30052",
        "30053",
        "30093",
        "30103",
        "31033",
        "31043",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "10-6": {
      stageId: "main_10-05",
      drops: [
        "30013",
        "3003",
        "30011",
        "30012",
        "30013",
        "30061",
        "30062",
        "30063",
        "30073",
        "31013",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "10-7": {
      stageId: "tough_10-06",
      drops: [
        "30083",
        "30084",
        "3003",
        "30011",
        "30012",
        "30013",
        "30061",
        "30062",
        "30063",
        "30073",
        "31013",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "10-8": {
      stageId: "main_10-07",
      drops: [
        "2001",
        "2002",
        "2003",
        "30021",
        "30022",
        "30023",
        "30041",
        "30042",
        "30043",
        "30083",
        "31023",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "10-9": {
      stageId: "tough_10-08",
      drops: [
        "30052",
        "30031",
        "30032",
        "30033",
        "30051",
        "30052",
        "30053",
        "30093",
        "30103",
        "31033",
        "31043",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "10-10": {
      stageId: "main_10-09",
      drops: [
        "30023",
        "30024",
        "3003",
        "30011",
        "30012",
        "30013",
        "30061",
        "30062",
        "30063",
        "30073",
        "31013",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "10-11": {
      stageId: "main_10-10",
      drops: [
        "30043",
        "30044",
        "2002",
        "2003",
        "30021",
        "30022",
        "30023",
        "30041",
        "30042",
        "30043",
        "30083",
        "31023",
        "ap_supply_lt_010",
        "randomMaterial_6",
        "2001"
      ],
      existence: true
    },
    "10-12": {
      stageId: "tough_10-11",
      drops: [
        "30093",
        "2002",
        "30021",
        "30022",
        "30023",
        "30041",
        "30042",
        "30043",
        "30083",
        "31023",
        "ap_supply_lt_010",
        "randomMaterial_6",
        "2001",
        "2003"
      ],
      existence: true
    },
    "10-14": {
      stageId: "tough_10-12",
      drops: [
        "31023",
        "31024",
        "30031",
        "30032",
        "30033",
        "30051",
        "30052",
        "30053",
        "30093",
        "30103",
        "31033",
        "31043",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "10-15": {
      stageId: "tough_10-13",
      drops: [
        "30073",
        "30074",
        "30031",
        "30032",
        "30033",
        "30051",
        "30052",
        "30053",
        "30093",
        "30103",
        "31033",
        "31043",
        "31053",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    "10-16": {
      stageId: "main_10-14",
      drops: ["30032", "30083", "ap_supply_lt_010", "randomMaterial_6"],
      existence: true
    },
    "10-17": {
      stageId: "tough_10-15",
      drops: [
        "31053",
        "3003",
        "30011",
        "30012",
        "30013",
        "30061",
        "30062",
        "30063",
        "30073",
        "31013",
        "ap_supply_lt_010",
        "randomMaterial_6"
      ],
      existence: true
    },
    罗德岛物资补给III: {
      stageId: "randomMaterial_6",
      drops: [
        "30012",
        "30022",
        "30032",
        "30042",
        "30052",
        "30062",
        "30013",
        "30023",
        "30033",
        "30043",
        "30053",
        "30063",
        "30073",
        "30083",
        "30093",
        "30103",
        "31013",
        "31023",
        "31033",
        "31043",
        "31053"
      ],
      existence: true
    }
  }
};
